<template>
    <div>
        <ProductSettinglist />
    </div>
</template>

<script>
import ProductSettinglist from "@/components/adminArin/pos_system/warehouse/product/Product_setting";
export default {
    name: "Productsetting",
    components: {
        ProductSettinglist
    }
}
</script>

<style scoped>

</style>
